let actionToken = 0;

function getIosAudioSessionPlugin() {
  if (
    !window.cordova ||
    window.cordova.platformId !== "ios" ||
    !window.webkit ||
    !window.webkit.messageHandlers
  ) {
    return null;
  }
  return window.IosAudioSession || null;
}

export function runIosAudioSessionAction(
  action,
  { delay = 0, onSuccess, onError } = {}
) {
  const token = ++actionToken;
  const plugin = getIosAudioSessionPlugin();
  if (!plugin || typeof plugin[action] !== "function") {
    return false;
  }

  const run = () => {
    if (token !== actionToken) {
      return;
    }
    try {
      plugin[action](
        (result) => {
          if (token === actionToken && typeof onSuccess === "function") {
            onSuccess(result);
          }
        },
        (error) => {
          if (token === actionToken && typeof onError === "function") {
            onError(error);
          }
        }
      );
    } catch (error) {
      if (token === actionToken && typeof onError === "function") {
        onError(error);
      }
    }
  };

  if (delay > 0) {
    setTimeout(run, delay);
  } else {
    run();
  }
  return true;
}
